import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import Env from "../util/env"

const renderRoutes = ({ routes }: any) => {
  if (!routes) return null
  return (
    <Switch>
      {routes.map((route: any, i: number) => {
        return (
          <Route
            key={i}
            exact={route.exact}
            path={route.path}
            render={(props) => 
              Env.isLogin() || !route.private ? (
                <route.component {...props} />
              ) : (
                <Redirect
                  to={{
                    pathname: "/auth",
                    state: {
                      from: props.location,
                      referrer: window.location.href,
                    },
                  }}
                />
              )
            }
          />
        )
      })}
      <Route key="last" exact={true} path="*">
        <Redirect to={{ pathname: routes[0].path }} />
      </Route>
    </Switch>
  )
}

export default renderRoutes
